import React, { useEffect, useState } from 'react'
import Gadjet from '../../images/gadjet.svg'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import ReportIcon from '@mui/icons-material/Report';
import SearchNot from '../../images/searchNot.png'
import FemaleIcon from '@mui/icons-material/Female';
import {  ArrowBack, ArrowForward, CycloneOutlined, DateRange, ImportantDevices, Sell, Sensors } from '@mui/icons-material'
import EmptyReturn from '../EmptyReturn';
import { useGlobalContext } from '../Context';
import MoveDetailStatus from '../MoveDetailStatus';
const moment=require('moment-jalaali')
const imp=['🔴','🟡','🔵','🟣','🟢']
const HistoryCardList = ({data,setSdata,value,flag,iindex,setIndex,gett,filterStatus,show,setShow}) => {
    const {openModalls2,openModalls}=useGlobalContext()
    useEffect(()=>gett&&gett(),[iindex])
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {entryDate}=item;
                    const birth=entryDate?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div key={index} style={{display:'flex', flexWrap:'wrap',gap:'4px'}} className='  col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 gap-3'>
                <div  className='ThemeCard' style={{borderRight:'2px solid #7FB020'}}>
                <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ArrowBack/>
                </span>
                    </div></div>
                <span> مقدار گذشته :</span>
                <span>{item?.oldCattleStatusTitle||item?.oldCattleLifeCycleTitle||item?.oldSensorStatusTitle}</span>
            </div>
            <div className='ThemeCardItem ' style={{position:'relative'}} onMouseOver={()=>{flag==='status'&&setIndex({index:index,currentSit:item});flag==='status'&&setShow(true)}} onMouseOut={()=>flag==='status'&&setShow(false)}>
            <div className='LogoFormT'><div><span>
                <ArrowForward/>
                </span>
                    </div></div>
                <span> مقدار حال :</span>
                <span>{item?.newCattleStatusTitle||item?.newCattleLifeCycleTitle||item?.newSensorStatusTitle}</span>
                {flag==='status'&&show&&index==iindex?.index&&<MoveDetailStatus data={filterStatus}/>}
            </div>
            
            {flag==='status'&&<div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ImportantDevices/>
                </span>
                    </div></div>
                <span>  سطح اهمیت :</span>
                <span>{imp[item?.newCattleStatusImportanceLevel]} {item?.newCattleStatusImportanceLevelTitle}</span>
            </div>}
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span>شماره گوش :</span>
                <span>{item?.cattleEarTagNumber}</span>
            </div>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span> شماره بدن :</span>
                <span>{item?.cattleBodyNumber}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}} src={Gadjet}/>

                </span>
                    </div></div>
                <span>شماره گردنبند :</span>
                <span>{item?.necklaceNumber?item?.necklaceNumber:'---'}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                <span>شماره سنسور :</span>
                <span>{item?.cattleSensorDeviceCode}</span>
            </div>
            
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>تاریخ  :</span>
                <span>{pbirth}</span>
            </div>
            {flag!=="cycle"&&<div  onClick={()=>{
                      setSdata(item);setIndex({index:index,currentSit:item});openModalls2()
                    }} className='btnCardDAm'>جزئیات</div>}
            {value==0&&<div  onClick={()=>{
                      setSdata(item);openModalls();if(flag==="status")setIndex({index:index,currentSit:item});
                    }} className='btnCardDAm'>متوجه شدم</div>}
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default HistoryCardList
